var _defs, _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\uB808\\uC774\\uC5B4_1",
    "data-name": "\\uB808\\uC774\\uC5B4_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 205 165",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #f1e9de;\n        stroke: #2f312d;\n        stroke-miterlimit: 10;\n        stroke-width: 5px;\n      }\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2.5,
    y: 2.5,
    width: 200,
    height: 160,
    rx: 36.27,
    ry: 36.27
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M107.98,52.07h7.59v-6.32h7.37v-5.99h7.59v-4.86h23.9v4.86h7.37v22.19h-7.37v6.16h-8.49v6.16h-7.59v6.16h-7.37v6.32h7.37v5.99h7.59v6.16h8.49v6.16h7.37v22.19h-7.37v4.86h-23.9v-4.86h-7.59v-6.16h-7.37v-6.16h-7.59v-5.18h-8.49v5.18h-7.37v6.16h-7.59v6.16h-7.59v4.86h-23.67v-4.86h-7.59v-22.19h7.59v-6.16h8.26v-6.16h7.59v-5.99h7.37v-6.32h-7.37v-6.16h-7.59v-6.16h-8.26v-6.16h-7.59v-22.19h7.59v-4.86h23.67v4.86h8.49v5.99h6.7v6.32h7.37v5.18h8.49v-5.18Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgX);
export default __webpack_public_path__ + "static/media/x.fc88b8da50fd11522fa9b561785ea27a.svg";
export { ForwardRef as ReactComponent };